import gql from 'graphql-tag';
import { DEAL_CALL_ACTIVITY_FRAGMENT } from './fragments/dealCallActivity.fragment';
import { DEAL_NOTE_ACTIVITY_FRAGMENT } from './fragments/dealNoteActivity.fragment';
import { DEAL_EMAIL_ACTIVITY_FRAGMENT } from './fragments/dealEmailActivity.fragment';
import { DEAL_SMS_ACTIVITY_FRAGMENT } from './fragments/dealSmsActivity.fragment';
import { DEAL_EVENT_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const DEAL_ACTIVITIES = gql`
  query DealActivities($input: DealActivitiesInput!) {
    dealActivity {
      result: dealActivities(input: $input) {
        error
        success
        list {
          ...DealCallActivityFields
          ...DealNoteActivityFields
          ...DealEmailActivityFields
          ...DealSmsActivityFields
          ...DealEventActivityFields
          __typename
        }
      }
    }
  }
  ${DEAL_CALL_ACTIVITY_FRAGMENT}
  ${DEAL_NOTE_ACTIVITY_FRAGMENT}
  ${DEAL_EMAIL_ACTIVITY_FRAGMENT}
  ${DEAL_SMS_ACTIVITY_FRAGMENT}
  ${DEAL_EVENT_ACTIVITY_FRAGMENT}
`;
